"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Notifications.css");
var react_1 = require("react");
var react_2 = require("react");
var __1 = require("../..");
exports.sendNotification = function (type, message, timeout) {
    window.dispatchEvent(new CustomEvent('showNotification', {
        detail: { type: type, message: message, timeout: timeout },
    }));
};
var NotificationsComp = function (_a) {
    var _b = _a.timeout, timeout = _b === void 0 ? 5000 : _b, props = __rest(_a, ["timeout"]);
    var _c = __read(react_1.useState([]), 2), events = _c[0], setEvents = _c[1];
    var count = react_1.useRef(0);
    react_2.useEffect(function () {
        window.addEventListener('showNotification', onShowNotification, true);
        return function () {
            window.removeEventListener('showNotification', onShowNotification, true);
        };
    }, [timeout]);
    function onShowNotification(e) {
        var _a = e.detail, type = _a.type, message = _a.message, tm = _a.timeout;
        var id = count.current++;
        setEvents(function (prevState) { return __spread([
            { id: id, type: type, message: message, show: true, timeout: tm || timeout }
        ], prevState); });
    }
    function hideToast(id) {
        var updatedEvents = events.map(function (event) {
            return event.id === id ? __assign(__assign({}, event), { show: false }) : event;
        });
        setEvents(updatedEvents);
    }
    function removeToast(id) {
        var filteredEvents = events.filter(function (event) { return event.id !== id; });
        setEvents(filteredEvents);
    }
    return (React.createElement("div", __assign({}, __1.setUIProps(props), { className: classnames_1.default('Notifications', props.className) }), events.map(function (event) { return (React.createElement(__1.Toast, { key: event.id, show: event.show, overlay: true, type: event.type, message: event.message, hasCloseButton: true, timeout: event.timeout, onClose: function () {
            hideToast(event.id);
        }, onEntered: function () {
            if (props.onEntered)
                props.onEntered(__assign({}, event));
        }, onExited: function () {
            removeToast(event.id);
            if (props.onExited)
                props.onExited(__assign({}, event));
        } })); })));
};
exports.Notifications = React.memo(NotificationsComp);
